/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { NoArgument } from "./NoArgument";

export class NoArgumentFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<NoArgument> {
    return super.deploy(overrides || {}) as Promise<NoArgument>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): NoArgument {
    return super.attach(address) as NoArgument;
  }
  connect(signer: Signer): NoArgumentFactory {
    return super.connect(signer) as NoArgumentFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NoArgument {
    return new Contract(address, _abi, signerOrProvider) as NoArgument;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [],
    name: "NoArgumentCalled",
    type: "event",
  },
  {
    inputs: [],
    name: "noArgument",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x6080604052348015600f57600080fd5b5060998061001e6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063568959ca14602d575b600080fd5b60336035565b005b7fc582abe1670c5a7f7cad8f171e4af03c793dd9f59fee6714179f56b6e9aea26f60405160405180910390a156fea2646970667358221220a892182dbbce898f68216cd1ea00edfe70bbb10b549cbd3f2566a11c2d3a920d64736f6c63430006040033";
